module.exports = __webpack_public_path__ + "static/media/Sedan5.9adfa497.jpg";